module.exports = __webpack_public_path__ + "img/pr-11.4ee74771.png";